import React from 'react'
import { useLocation } from 'react-router-dom'
import UltraResponsiveNav from './UltraResponsiveNav'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()

  // Pages qui n'ont pas besoin de navigation
  const noNavigationPages = ['/login', '/register', '/']

  const shouldShowNavigation = !noNavigationPages.includes(location.pathname)

  return (
    <div
      className="min-h-dvh relative"
      style={{ background: 'var(--sl-bg-gradient)' }}
    >
      {/* ── Backdrop desktop — ambiance autour de la colonne (lg+) ── */}
      <div className="hidden lg:block fixed inset-0 pointer-events-none" aria-hidden>
        {/* Glow ambiant */}
        <div
          style={{
            position: 'absolute', top: '-10%', left: '50%', transform: 'translateX(-50%)',
            width: '90vw', height: '60vh',
            background: 'radial-gradient(ellipse 60% 50% at 50% 0%, var(--sl-hero-glow) 0%, transparent 70%)',
          }}
        />
        {/* Hex pattern */}
        <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 'var(--sl-hex-opacity)' as any }}>
          <defs>
            <pattern id="hx-shell" x="0" y="0" width="44" height="50" patternUnits="userSpaceOnUse">
              <polygon points="22,2 41,13 41,37 22,48 3,37 3,13" fill="none" stroke="var(--sl-accent)" strokeWidth="0.9" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hx-shell)" />
        </svg>
        {/* Wordmark géant en filigrane */}
        <div
          style={{
            position: 'absolute', bottom: '4%', left: '50%', transform: 'translateX(-50%)',
            fontFamily: "'Bodoni Moda', serif", fontWeight: 900, fontStyle: 'italic',
            fontSize: 'clamp(80px, 14vw, 200px)', lineHeight: 1,
            color: 'var(--sl-text)', opacity: 0.035,
            whiteSpace: 'nowrap', userSelect: 'none',
          }}
        >
          Solim
        </div>
      </div>

      {/* ── Colonne app — pleine largeur mobile, 480px centrée desktop ── */}
      <div
        className="relative w-full lg:max-w-[480px] lg:mx-auto lg:min-h-dvh lg:border-x"
        style={{
          borderColor: 'var(--sl-surface-border)',
          boxShadow: 'var(--sl-shell-shadow, none)',
        }}
      >
        {children}
      </div>

      {/* Navigation ultra-responsive */}
      {shouldShowNavigation && (
        <UltraResponsiveNav />
      )}
    </div>
  )
}

export default Layout
